/* eslint max-len: 0 */
/* eslint no-useless-escape: 0 */

module.exports = {
  addressValidationSvcEnabled: true,
  taxSvcEnabled: true,
  NACOfranOwnerId: 37,
  taxAddonSvcEnabled: true,
  addressFormat: 'addressLine1,city,state,postalCode',
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      addressVerificationRequired: true,
      isShippingAddressRequired: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '3',
      refId: '0',
      name: 'WW4Diabetes',
      addressVerificationRequired: true,
      isShippingAddressRequired: true,
    },
    {
      id: '4',
      refId: '1',
      name: '@Work eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },

    {
      id: '6',
      refId: '6',
      name: 'Personal Coaching',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '7',
      refId: '7',
      name: 'Total Access',
      addressVerificationRequired: true,
      isShippingAddressRequired: true,
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '13',
      refId: '1',
      name: 'Online + National Accounts',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '0',
      name: 'Online iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Virtual Group Coaching + Digital',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex: "^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex: "^$|^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    city: {
      regex: '^[a-zA-Z-. ]*[a-zA-Z]+[a-zA-Z-. ]*$',
    },
    postalCode: {
      type: 'string',
      min: 5,
      max: 5,
      regex: '^\\d{5}$',
      regexFlags: '',
      numbersOnly: true,
    },
    phoneNo: {
      max: 10,
    },
    state: {
      required: true,
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
      { id: 4, tid: 24, name: 'DISCOVER', ccName: 'DISCOVER' },
    ],
  },
};
